import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/name.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "login" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "dropdown-name" }

import { idmAuth, logout } from "@/utils/auth";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { getUserInfo } from "@/services/login";
import { ElMessage } from "element-plus";
import GuidePage from "./components/guidePage.vue";
import ModelCycle from "./components/modelCycle.vue";
import CoreAdvantage from "./components/coreAdvantage.vue";
import ApplyExample from "./components/applyExample.vue";
import store from "@/store";
import { mainApi } from "@/services/api";

import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.min.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'asLeadsPortal',
  setup(__props) {

const modules = [Mousewheel, Pagination];

const route = useRoute();

// 核心优势页面swiper
const coreAdvantageRef = ref();

const activeSlider = ref<number>(0);

// 登录用户的token信息
const token = ref();
// 用户信息
const userName = computed(() => {
  const info = store.state.base.userInfo || {};
  return info?.userName || "";
});

// 线索分类数据
const leadsCountData = ref();
// 登录
const login = () => {
  // console.log("login");
  idmAuth().then((res) => {
    if (res === "success") {
      console.log("idm 登录成功");
    }
  });
};

// 获取用户信息
const getUserInfoAPI = (token: string) => {
  getUserInfo(token).then((res: any) => {
    if (res.resultCode === 200) {
      // console.log("userData ", res.data);
      store.commit("setToken", token as string);
      localStorage.setItem("idmToken", token as string);
      store.commit("setUserInfo", res.data);
    } else if (res.resultCode === 5002) {
      store.commit("setToken", "");
      localStorage.setItem("idmToken", "");
      store.commit("setUserInfo", {});
      ElMessage({
        showClose: true,
        message: res.errMsg,
        type: "warning",
      });
      window.location.reload();
    } else {
      // 因为没用统一的请求方法
      ElMessage({
        showClose: true,
        message: res.errMsg || "当前系统繁忙，请稍后再试，谢谢！",
        type: "warning",
      });
    }
  });
};

// 页面切换
const slideChange = (swiper: any) => {
  activeSlider.value = swiper?.activeIndex;
  if (swiper?.activeIndex === 2) {
    // 切换到第三页
    // console.log(swiper?.activeIndex);
    coreAdvantageRef.value.slideRestart();
  }
};

// 获取首页看板数据
const getLeadsCountData = () => {
  mainApi.leadsCountByTypeApi().then((res: any) => {
    if (res?.success) {
      // console.log("res :>> ", res);
      leadsCountData.value = res.data;
    }
  });
};

// 退出登录
const handleCommand = (cmd: string) => {
  if (cmd === "logout") {
    logout();
  }
};

onMounted(() => {
  // console.log("mounted");
  token.value =
    route.query.token ||
    store.state.base.token ||
    localStorage.getItem("idmToken");
  console.log("token.value :>> ", token.value);
  if (token.value) {
    store.commit("setToken", token.value);
    localStorage.setItem("idmToken", token.value);
    getUserInfoAPI(token.value);
    getLeadsCountData();
  } else {
    store.commit("setToken", "");
    localStorage.setItem("idmToken", "");
  }
});

onUnmounted(() => {
  // console.log("unmounted");
});

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!token.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: login
              }, "登录"))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_dropdown, {
                  onCommand: handleCommand,
                  "popper-class": "logout-popper"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createTextVNode("退出")
                          ])),
                          _: 1,
                          __: [0]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(userName.value), 1)
                  ]),
                  _: 1
                })
              ]))
        ])
      ])
    ]),
    _createVNode(_unref(Swiper), {
      direction: 'vertical',
      slidesPerView: 1,
      mousewheel: true,
      speed: 1000,
      modules: modules,
      onSlideChange: slideChange,
      class: "mySwiper"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(GuidePage, { leadsData: leadsCountData.value }, null, 8, ["leadsData"])
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(ModelCycle)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(CoreAdvantage, {
              ref_key: "coreAdvantageRef",
              ref: coreAdvantageRef
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(ApplyExample)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})